// biome-ignore lint/suspicious/noExplicitAny: GTM's dataLayer accepts arbitrary event payloads
export const trackGTMEvent = (props: any) => {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push(props);
  }
};
